export default "__VITE_ASSET__C349LlH1__"